<template>

	<div class="card">
		<div class="card-body">

			<div v-if="isLoading" class="text-center p-5">
				<div class="spinner-border text-secondary" role="status">
					<span class="visually-hidden">Loading...</span>
				</div>
			</div>
			<div v-else class="mt-4">

				<div v-if="isLoading" class="text-center p-5">
					<div class="spinner-border text-secondary" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
				</div>
				<div v-else-if="events.length" v-for="(event, index) in events" :key="index">

					<div v-if="event.type == 'version'" class="my-4">
						<div class="small text-muted text-center">
							<span class="fw-bold">v{{ event.data.version }}</span>
							was uploaded {{ formatDate(event.data.created_at) }}
							by {{ event.data.uploader.name }}
						</div>
					</div>
					<div v-else-if="event.type == 'approval'" class="my-4">
						<div class="small text-muted text-center my-3">
							<span class="fw-bold">v{{ event.data.version }}</span>
							was approved {{ formatDate(event.data.approved_at) }}
						</div>
					</div>
					<div v-if="event.type == 'comment'" class="my-4">
						<comment
							:endpoint="creativeAssetEndpoint + '/comments'"
							:comment="event.data"
							@deleted="remove(event.data.id)"
						/>
					</div>

				</div>

			</div>

			<!-- Divider -->
			<hr>

			<!-- Add Comment Form -->
			<div class="row">
				<div class="col-auto">

					<!-- Avatar -->
					<avatar :model="creativeAsset.creator" size="sm"></avatar>

				</div>
				<div class="col ms-n2">

					<label class="visually-hidden">
						Leave a comment...
					</label>
					<textarea
						v-model="body"
						name="body"
						class="form-control form-control-flush"
						data-autosize
						rows="1"
						placeholder="Leave a comment"></textarea>

				</div>
				<div class="col-auto">

					<!-- Submit -->
					<button
						@click="addComment"
						class="btn btn-sm btn-white px-4 py-2 rounded-pill">
						Submit
					</button>

				</div>
			</div><!--/.row-->

		</div><!--/.card-body-->
	</div><!--/.card-->

</template>

<script>

	import autosize from 'autosize';
	import Avatar from '../Avatar.vue';
	import Comment from '../Comment.vue';

	import dayjs from 'dayjs';

	export default {

		props: ['creativeAssetData', 'creativeAssetEndpoint'],

		components: {
			'avatar': Avatar,
			'comment': Comment
		},

		data() {
			return {
				creativeAsset: this.creativeAssetData,
				events: [],
				body: '',
				isLoading: true,
			}
		},

		mounted() {

			autosize(document.querySelectorAll('[data-autosize]'));

			this.fetch();

		},

		computed: {

		},

		methods: {

			formatDate(date) {
				return dayjs(date).format('MMM D, YYYY h:mma');
			},

			fetch() {
				this.isLoading = true;
				axios.get(this.creativeAssetEndpoint + '/events')
					.then((response) => {
						console.log(response.data);
						this.events = response.data;
						this.isLoading = false;
					})
					.catch((error) => {
						console.error(error);
					});
			},

			addComment() {
				axios.post(this.creativeAssetEndpoint + '/comments', {
					body: this.body
				}).then(({data}) => {
					this.body = '';
					console.log(data);
					// flash('Your reply has been posted.');
					this.events.push({
						date: data.created_at,
						type: 'comment',
						data: data
					});
					// window.scrollTo(0,document.body.scrollHeight);

					// resize textarea
					var textareas = document.querySelectorAll('[data-autosize]');
					textareas.forEach((textarea) => {
						textarea.style.height = '41px';
					});
				});
			},

			remove(commentId) {
				var events = this.events;
				console.log(events);
				this.events = events.filter(function (event) {
					return event.type != 'comment' || event.data.id != commentId;
				});
				this.$emit('removed');
			},

		}

	}

</script>
